<template>
    <div class="container-custom">
        <div class="step step--intro d-flex text-center">
            <div class="align-self-center w-100 p-3 intro">
                <figure class="md-4">
                    <img class="img-fluid" alt="Iqos Pocket" src="@/assets/logo.png" />
                </figure>
                <p class="text-center p-3">
                    Ai propriul ghid digital chiar la tine în buzunar.
                    <br />Află sau reamintește-ți cum funcționează dispozitivul tău IQOS, urmărind video-urile cu instrucțiuni dedicate.
                </p>

                <button @click="goToHow" class="btn btn--primary btn--lg mt-5" type="button">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Intro",
    data:function(){
        return{
           
        }
    },
    methods: {
        goToHow() {
            this.$router.push({ name: "how-to-use" });
        }
    },

    mounted() {
     

        // setTimeout(function() {
        // 	$this.goToHow();
        // }, 6000);
        
    },
    created(){
      
    
    }
};
</script>
